/**
 * OrbDocCoreConceptsClosedCircuitAROrbDocCoreConceptsClosedCircuitARPage
 *
 * Page component for OrbDocCoreConceptsClosedCircuitAROrbDocCoreConceptsClosedCircuitARPage
 * Path: /ar/docs/core-concepts/closed-circuit
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsClosedCircuitARDocScreenView as __OrbDocCoreConceptsClosedCircuitARDocScreenView } from '@/components/traits/OrbDocCoreConceptsClosedCircuitARDocScreenView';
import { OrbDocCoreConceptsClosedCircuitARDocAnalyticsView as __OrbDocCoreConceptsClosedCircuitARDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsClosedCircuitARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsClosedCircuitAROrbDocCoreConceptsClosedCircuitARPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsClosedCircuitAROrbDocCoreConceptsClosedCircuitARPage(_props: OrbDocCoreConceptsClosedCircuitAROrbDocCoreConceptsClosedCircuitARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"الدائرة المغلقة","description":"كل تفاعل حلقة من حدث عودةً إلى الشاشة، والمترجم يتحقق من كل حلقة فيها.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/closed-circuit"},{"locale":"ar","path":"/ar/docs/core-concepts/closed-circuit"},{"locale":"sl","path":"/sl/docs/core-concepts/closed-circuit"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsClosedCircuitARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsClosedCircuitARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocCoreConceptsClosedCircuitAROrbDocCoreConceptsClosedCircuitARPage;
